import dynamic from 'next/dynamic';
import Head from 'next/head';

import ErrorBoundary from '@otovo/shared/components/ErrorBoundary/ErrorBoundary';
import NextPageRoot from '@otovo/shared/components/NextPageRoot';

import TrustpilotScriptLoader from '@otovo/shared/components/TrustpilotScriptLoader';
import { Otovo$Config } from '@otovo/shared/types/otovoweb';
import { Sanity$Document } from '@otovo/shared/types/sanityTypes';
const StorefrontNav = dynamic(() => import('./StorefrontNav'));

const CustomFooter = dynamic(
  () =>
    import('./SanityLandingPage/components/Footer/FranceFooter/CustomFooter'),
);
const Footer = dynamic(
  () => import('./SanityLandingPage/components/Footer/Footer'),
);

type Props = {
  children: React.ReactNode;
  config: Otovo$Config;
  hideMenu?: boolean;
  hideFooter?: boolean;
  sanityDocument?: Sanity$Document;
  menuRenderer?: () => React.ReactNode | null;
};

const StorefrontPage = (props: Props) => {
  const resolveFooter = (market: string, hideFooter: boolean) => {
    if (hideFooter) {
      return null;
    }
    return market === 'fr' ? <CustomFooter /> : <Footer />;
  };

  const {
    children,
    config,
    hideMenu = false,
    hideFooter = false,
    sanityDocument,
    menuRenderer,
  } = props;

  function renderNav() {
    if (hideMenu) {
      return null;
    }

    const rendered = menuRenderer?.();

    if (rendered) {
      return rendered;
    }

    return <StorefrontNav sanityDocument={sanityDocument} />;
  }

  return (
    <NextPageRoot configValues={config}>
      <Head>
        <link
          rel="shortcut icon"
          type="image/x-icon"
          href={config.BU_CONFIG.favicon}
          key={`favicon-${config.BU_CONFIG.company_name}`}
        />
        {config.BU_CONFIG.isMultiLocaleBu && (
          <script
            src={`/${config.BU_CONFIG.locale}/js/routerProxy.js`}
            type="text/javascript"
          />
        )}
      </Head>
      <div className="relative flex h-screen flex-col bg-white">
        {renderNav()}
        <ErrorBoundary name="Storefront top level error boundary">
          <main className="flex flex-[1_0_auto] flex-col">{children}</main>
        </ErrorBoundary>
        {resolveFooter(config.BU_CONFIG.market, hideFooter)}
      </div>
      <TrustpilotScriptLoader />
    </NextPageRoot>
  );
};

export default StorefrontPage;
